var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgErrorToastMessage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "48px",
    height: "48px",
    viewBox: "0 0 48 48",
    enableBackground: "new 0 0 48 48",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "surface1"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#E91D15",
    d: "M24,47.699C11,47.699,0.301,37,0.301,24S11,0.301,24,0.301S47.699,11,47.699,24S37,47.699,24,47.699z  M24,3.102C12.5,3.102,3.102,12.5,3.102,24S12.5,44.898,24,44.898S44.898,35.5,44.898,24S35.5,3.102,24,3.102z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E91D15",
    d: "M6.313,38.406l31.746-31.75l1.91,1.91l-31.75,31.75L6.313,38.406z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgErrorToastMessage);
export default __webpack_public_path__ + "static/media/Error Toast Message.e73ce450d07616e7b9d601bbe4e80e78.svg";
export { ForwardRef as ReactComponent };